// The grab bar at the top of a bottom sheet.
//
// It replaced a gold rule that ran the full width of every sheet. The rule was
// decoration: it said "this is ours" and nothing else, and at four sheets deep
// it started reading as a mistake rather than a choice. A handle is the same
// two pixels of ink doing a job — it names the edge you can drag from, which is
// what people already expect at the top of a sheet on a phone.
import React from "react";

function SheetHandle() {
  return (
    <div aria-hidden style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
      <div style={{ width: 34, height: 4, borderRadius: 2, background: "rgba(255,255,255,0.14)" }} />
    </div>
  );
}

export default SheetHandle;
